import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../../lib/preact-pure-component'
import classNames from 'classnames'

interface Props {
  active: boolean
}

export class Card extends PureComponent<Props, {}> {
  render() {
    const classes = classNames(style.card, { [style.cardActive]: this.props.active })
    return <div className={classes}>{this.props.children}</div>
  }
}
